import * as Q from "q";
import { isDefined } from "ionic-angular/util/util";
import { OperationResult } from "./operation-result";
import { ActionOptionsArgs } from "../../store/actions/base-actions";
import { BaseObject } from "../../business-objects/base-object/base-object.model";
import { isEntitySubResource } from "../../util/utils";
import { VasAppFacade } from "../../../vas/services/vas-app-facade.service";
import { SyncUpItem } from "../../../vas/business-objects/sync-up-item/sync-up-item.model";
import { ChangeQItem } from "./item";
import { JobDataFacade } from '../../../vas/business-objects/job-data/job-data.facade';
import { AccountObjectFacade } from '../../../vas/business-objects/account-object/account-object.facade';

export interface SyncUpResponseHandlerActionOptions {
    shouldDeleteChangeQItem?: boolean;
    shouldDeleteLocalItem?: boolean;
    shouldRefreshItem?: boolean;
    shouldNotifyUser?: boolean;
    shouldAutoResolveVersionConflict?: boolean;
    shouldBumpVersion?: boolean;
}

export class ResultHandlerAction {

    options: SyncUpResponseHandlerActionOptions;

    constructor(
        protected result: OperationResult,
        protected appFacade: VasAppFacade
    ) {
    }

    async handle(): Promise<any> {

        try {
            console.log("handler action", this.result.item.entity, this.result.item.id, this.options);
        } catch (e) {
            console.log("membership warning!!!", this.result);
        }

        await this.deleteChangeQItem();
        await this.refreshItem();
        await this.deleteLocalItem();
        await this.autoResolveVersionConflict();
        await this.shouldNotifyUser();
        await this.shouldBumpVersion();
    }

    setOptions(options: SyncUpResponseHandlerActionOptions): ResultHandlerAction {
        this.options = options;
        return this;
    }

    protected getOption(key, defaultValue = false): boolean {

        if (!isDefined(this.options[key])) {
            return defaultValue;
        }
        return this.options[key];
    }

    protected async deleteChangeQItem(): Promise<any> {

        if (!this.getOption("shouldDeleteChangeQItem")) {
            return;
        }

        try {
            this.appFacade.objects.syncUpItem.store.removeByKey(this.result.item.key);
        } catch (e) {
            console.error("error deleting changeQItem.", e);
        }
    }

    protected async deleteLocalItem(): Promise<any> {

        if (!this.getOption("shouldDeleteLocalItem")) {
            return;
        }

        this.appFacade.objects.removeObject(
            this.result.item.entity,
            {id: this.result.item.id} as BaseObject,
            {persistable: true, restful: false} as ActionOptionsArgs
        );
    }

    protected async refreshItem(): Promise<any> {

        if (!this.getOption("shouldRefreshItem")) {
            return;
        }

        switch (true) {
            case this.result.item.entity === "account": {
                return this.appFacade.objects.account.syncOne(
                    this.result.item.id
                ).subscribe(
                    () => {
                        // nop
                    },
                    error => {
                        console.error(error);
                    }
                );
            }
            case this.result.item.entity === "user": {
                return this.appFacade.objects.user.syncOne(
                    this.result.item.id
                ).subscribe(
                    () => {
                        // nop
                    },
                    error => {
                        console.error(error);
                    }
                );
            }
            case isEntitySubResource(this.result.item.entity): {
                const facade = this.appFacade.objects.getFacadeByEntity(
                    this.result.item.entity
                ) as JobDataFacade<any, any, any>;

                return facade.syncOneItem(
                    this.result.item.account,
                    this.result.item.parentId,
                    this.result.item.id
                ).subscribe(
                    () => {
                        // nop
                    },
                    error => {
                        console.error(error);
                    }
                );
            }
            default: {
                const facade = this.appFacade.objects.getFacadeByEntity(
                    this.result.item.entity
                ) as AccountObjectFacade<any, any, any>;
                return facade.syncOne(
                    this.result.item.account,
                    this.result.item.id
                ).subscribe(
                    () => {
                        // nop
                    },
                    error => {
                        console.error(error);
                    }
                );
            }
        }
    }

    protected async autoResolveVersionConflict(): Promise<any> {

        if (!this.getOption("shouldAutoResolveVersionConflict")) {
            return;
        }

        this.result.item = new ChangeQItem({
            ...this.result.item,
            version: this.result.item.version + 1
        });

        return this.appFacade.changeLog.addItem(this.result.item.key, this.result.item);
    }

    protected shouldNotifyUser(): Promise<any> {

        if (!this.getOption('shouldNotifyUser')) {
            return Promise.resolve();
        }

        this.appFacade.objects.syncUpItem.store.updateFromOperationResult(
            this.result
        );
    }

    protected async shouldBumpVersion(): Promise<any> {

        if (!this.getOption("shouldBumpVersion")) {
            return;
        }

        if (this.result.item.entity === "job") {
            this.appFacade.objects.job.store.bumpVersion(this.result.item.id);
            return;
        }

        if (this.result.item.entity === "field") {
            this.appFacade.objects.field.store.bumpVersion(this.result.item.parentId, this.result.item.id);
            return;
        }
    }
}



// WEBPACK FOOTER //
// ./src/core/services/sync-up/result-handler-action.ts